import {Alert} from "@mui/joy";
import {createFileRoute} from "@tanstack/react-router";

function JobPage() {
    return <Alert>under construction</Alert>
}

export const Route = createFileRoute("/_auth/job/$id")({
    component: JobPage
});

